<template>
  <section class="entrace-info">
    <h5>---入场信息---</h5>
    <ul>
      <li>
        <span>入场时间</span>
        <span>{{ entraceInfo.beginDate }}</span>
      </li>
      <li>
        <span>收费员</span>
        <span>{{ entraceInfo.crtName }}</span>
      </li>
      <li>
        <span>收费时间</span>
        <span>{{ entraceInfo.crtTime }}</span>
      </li>
      <li class="entrace-info-pic">
        <span>入场照片</span>
        <!-- <img :src="entraceInfo.platenumImage" alt="" /> -->
        <el-image
          v-for="url in entraceInfo.platenumImage"
          v-bind:key="url"
          style="width: 80px; height: 80px;border-radius: 5px;margin-right:10px"
          :src="url"
          :preview-src-list="entraceInfo.platenumImage"
        >
        </el-image>
      </li>
    </ul>
  </section>
</template>
<script>
export default {
  name: "entrace-info",
  props: {
    entraceInfo: {
      type: Object,
      default: () => {
        return {
          beginDate: "",
          crtName: "",
          crtTime: "",
          platenumImage: [],
        };
      },
    },
  },
};
</script>
<style scoped>
.entrace-info {
  padding-bottom: 20px;
  box-sizing: border-box;
  width: 45%;

}
h5 {
  padding: 10px 0;
  font-weight: bold;
}
ul {
  background: #eee;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
}
ul li {
  padding: 5px 0;
  box-sizing: border-box;
}
ul li span:nth-child(1) {
  display: inline-block;
  /* padding-right:10px;
    box-sizing: border-box; */
  width: 90px;
  font-weight: bold;
}
ul li span:nth-child(2) {
  display: inline-block;
  color: #2a9df5;
  font-weight: bold;
}
.entrace-info-pic {
  display:flex;
  align-items: flex-start;
}
</style>
